import { useSelector } from 'react-redux';

// Selectors
import { getMemberBySlug } from 'Shared/selectors/Members.selector';

// Types
import { Member } from 'Shared/types/Member.type';

interface UseMemberProps {
  slug: string;
}

export const useMember = ({ slug }: UseMemberProps) => {
  const member: Member = useSelector(state =>
    getMemberBySlug(state, {
      userSlug: slug,
    })
  );

  const isThirdPartyUser = member && !member.primary;

  return {
    member,
    isThirdPartyUser,
  };
};
